var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13492",
    transform: "translate(3.949 3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 42",
    transform: "translate(0 8.002)",
    style: {
      strokeLinecap: "round",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    },
    d: "M0 0h16.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 55",
    transform: "translate(0 1.869)",
    style: {
      strokeLinecap: "round",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    },
    d: "M0 0h16.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 56",
    transform: "translate(0 14.135)",
    style: {
      strokeLinecap: "round",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    },
    d: "M0 0h16.1"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 953",
    cx: 1.868,
    cy: 1.868,
    r: 1.868,
    transform: "translate(2.9)",
    style: {
      fill: "#33312f",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 955",
    cx: 1.868,
    cy: 1.868,
    r: 1.868,
    transform: "translate(10.753 6.133)",
    style: {
      fill: "#33312f",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 954",
    cx: 1.868,
    cy: 1.868,
    r: 1.868,
    transform: "translate(5.567 12.266)",
    style: {
      fill: "#33312f",
      stroke: "#c9c9c9",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 7012",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcW);
export default __webpack_public_path__ + "static/media/filter_ic_W.317b0a3f9f249c48525fd299d8a884ac.svg";
export { ForwardRef as ReactComponent };